import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  Output,
  Pipe,
  PipeTransform,
  ViewChild,
} from '@angular/core';

import { RmSelect } from '../rm-select/rm-select.types';
import { fromEvent, Subscription, timer } from 'rxjs';
import { debounce, distinctUntilChanged, map } from 'rxjs/operators';

@Component({
  selector: 'rm-status-select',
  templateUrl: './rm-status-select.component.html',
  styleUrls: ['./rm-status-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RmStatusSelectComponent implements OnInit {
  public innerWidth = 0;
  isResponsive = false;
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 768) {
      this.isResponsive = true;
    } else {
      this.isResponsive = false;
    }
  }

  @ViewChild('inputFilterSearch')
  set input(value: ElementRef<HTMLInputElement>) {
    if (value) {
      this._input = value;
      this.setFocusInputSearch();
      this.patchFilterArgParams();
      this.watchInputSearch();
    }
  }

  @Input()
  placeholderText = '';

  @Input()
  titleText = '';

  @Input()
  mode: RmSelect.Type = 'SINGLE';

  @Input()
  listWidth = '';

  @Input()
  hasError = false;

  _isLoading = false;
  _firstLoad = true;

  @Input()
  @HostBinding('class.is-loading')
  set isLoading(value: boolean) {
    this._isLoading = value;
    //if is changed is loaded to false for second time (latter than load), we open the panel
    if (this._isLoading == false) {
      if (this._firstLoad) {
        this._firstLoad = false;
      }
    }
  }

  get isLoading() {
    return this._isLoading;
  }

  @Input()
  @HostBinding('class.is-disabled')
  disabled!: boolean;

  _items;
  @Input()
  set items(items) {
    this._items = items;
    if (this.activeItems) {
      this.selectedItem = this.items.find((fil) => fil.id == this.activeItems);
    }
  }
  get items() {
    return this._items;
  }

  _activeItems;
  @Input()
  set activeItems(activeItems) {
    this._activeItems = activeItems;
    if (this.items) {
      this.selectedItem = this.items.find((fil) => fil.id == this.activeItems);
    }
  }
  get activeItems() {
    return this._activeItems;
  }

  @Input()
  inputHeight = '36px';

  @Input()
  type = '';

  @Output()
  changeItems = new EventEmitter();

  @Output()
  addElement = new EventEmitter<MouseEvent>();

  checkBoxItems: any[] = [];
  filterArgs: { title: string } = { title: '' };
  selectedItem!: { title: string; value: string; id: string; color: string };

  private _input: ElementRef<HTMLInputElement>;
  private sub$ = new Subscription();

  firstLoad = true;
  menuIsOpen = false;

  constructor(private cdr: ChangeDetectorRef, private elRef: ElementRef) {}

  ngOnInit(): void {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 768) {
      this.isResponsive = true;
    } else {
      this.isResponsive = false;
    }
  }

  async delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  changeSelect(item) {
    if (
      this.selectedItem === item ||
      (!this.selectedItem && item.value == null)
    ) {
      return;
    }
    this.selectedItem = item;
    this.activeItems = [item];
    this.changeItems.next(this.activeItems);
    this.draw();
  }

  changeCheckBox(evt, item) {
    if (evt.checked) {
      //this.checkBoxItems.push(item.value);
      this.activeItems.push(item);
    } else {
      this.activeItems.splice(
        this.activeItems.findIndex(function (i) {
          return i.value === item.value;
        }),
        1
      );
    }

    this.changeItems.next(this.activeItems);
    this.draw();
  }

  searchCheckFilters(item) {
    if (
      this.activeItems.filter((element) => element.value == item.value).length >
      0
    ) {
      return true;
    } else {
      return false;
    }
  }

  addElementHandle(evt: MouseEvent) {
    if (evt) {
      this.addElement.next(evt);
    }
  }

  clearInput(mode: 'in' | 'out') {
    this.activeItems = [];
    this.filterArgs.title = '';
    this.draw();

    if (mode === 'in') {
      this.changeItems.next(this.activeItems);
    }
  }

  private draw() {
    this.cdr.detectChanges();
  }

  private setFocusInputSearch() {
    if (this._input) {
      this._input.nativeElement.focus();
    }
  }

  private patchFilterArgParams() {
    if (this._input && this.filterArgs.title) {
      this._input.nativeElement.value = this.filterArgs.title;
    }
  }

  private watchInputSearch() {
    this.sub$.add(
      fromEvent(this._input.nativeElement, 'input')
        .pipe(
          distinctUntilChanged(),
          debounce(() => timer(450)),
          map((res) => (res.target as HTMLTextAreaElement).value as string)
        )
        .subscribe(this.changeKeyword.bind(this))
    );
  }

  private changeKeyword(keyword: string) {
    this.filterArgs = {
      title: keyword.toString().toLocaleLowerCase(),
    };
    this.draw();
  }

  menuClosed() {
    this.menuIsOpen = false;
    this.draw();
  }

  menuOpened() {
    this.menuIsOpen = true;
    this.draw();
  }
}

@Pipe({
  name: 'searchFilter',
  pure: false,
})
export class SearchFilterPipe implements PipeTransform {
  transform(items: RmSelect.Items, filter: { title: string }): any {
    if (!items?.length || !filter?.title) {
      return items;
    }

    return items.filter((item) =>
      item.title.match(new RegExp(filter.title, 'i'))
    );
  }
}
